import React, { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useShop } from "../context/ShopContext";
import ProductCard from "../components/ProductCard";
import { PageTitle } from "../components/Shared";
import Seo from "../components/Seo";

const seoData = {
  it: {
    description:
      "Acquista plugin software, moduli Prestashop, connettori Perfex CRM e servizi di sviluppo siti web nello shop ufficiale ideamedia.",
  },
  en: {
    description:
      "Buy software plugins, Prestashop modules, Perfex CRM connectors and website development services in the official ideamedia shop.",
  },
};

const Shop = () => {
  const { t, lang, products, categories, loading } = useShop();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCat = searchParams.get("cat") || "";
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    let list = products;
    if (activeCat) list = list.filter((p) => p.categories.includes(activeCat));
    if (query.trim()) {
      const q = query.toLowerCase();
      list = list.filter(
        (p) =>
          p.name[lang].toLowerCase().includes(q) ||
          p.shortDescription[lang].toLowerCase().includes(q)
      );
    }
    return list;
  }, [products, activeCat, query, lang]);

  return (
    <div data-testid="shop-page">
      <Seo title={t("shopTitle")} description={seoData[lang].description} />
      <PageTitle title={t("shopTitle")} />

      <div className="idm-container idm-shop-layout">
        <div className="idm-shop-toolbar">
          <div className="idm-cat-filters" data-testid="category-filters">
            <button
              className={!activeCat ? "active" : ""}
              onClick={() => setSearchParams({})}
              data-testid="filter-all"
            >
              {t("allCategories")}
            </button>
            {categories.map((c) => (
              <button
                key={c.slug}
                className={activeCat === c.slug ? "active" : ""}
                onClick={() => setSearchParams({ cat: c.slug })}
                data-testid={`filter-${c.slug}`}
              >
                {c.name[lang]}
              </button>
            ))}
          </div>
          <div className="idm-search">
            <Search size={15} />
            <input
              type="text"
              placeholder={t("searchPlaceholder")}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              data-testid="shop-search-input"
            />
          </div>
        </div>

        {loading ? (
          <div className="idm-loading" data-testid="loading">
            <span className="idm-spinner" />
          </div>
        ) : (
          <>
            <p className="idm-results-count" data-testid="results-count">
              {t("showingAll")} {filtered.length}{" "}
              {filtered.length === 1 ? t("result") : t("results")}
            </p>

            <div className="idm-product-grid" data-testid="product-grid">
              {filtered.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Shop;
